import React from 'react'
import classNames from 'classnames'
import { NavLinkProps, NavLink } from 'react-router-dom'

import styles from './StyledNavLink.module.css'

export interface StyledNavLinkProps extends NavLinkProps {
  disabled?: boolean
}

export const StyledNavLink: React.FC<StyledNavLinkProps> = ({
  children,
  disabled = false,
  ...props
}) => {
  return (
    <NavLink
      className={classNames(styles.link, {
        [styles.enabled]: !disabled,
        [styles.disabled]: disabled,
      })}
      {...props}
    >
      {children as React.ReactNode}
    </NavLink>
  )
}
